import {ActionType, createReducer} from 'typesafe-actions';
import {ExchangeTokenWithInternalAdapterResponse} from '../../../actions/aiAgent/payloads';
import {actions} from '../../../index';
import {AiAgentsResponse, SsoResponse} from '../../../types/AiAgent';

export type AiAgentStateType = {
    token?: ExchangeTokenWithInternalAdapterResponse;
    fetchTokenInProgress?: boolean;
    aiAgentsListLoading: boolean;
    aiAgentsListLoadingError?: {error:string};
    aiAgentsList?: AiAgentsResponse;
    checkTenantInProgress?: boolean;
    tennatChecktatus?: string;
    accessLink?: SsoResponse;
    tenantId?: number;
    sign_in_link?:string
};

export const initialState: AiAgentStateType = {
    fetchTokenInProgress: undefined,
    token: undefined,
    checkTenantInProgress: undefined,
    aiAgentsListLoadingError:undefined,
    aiAgentsListLoading: false,
    sign_in_link: undefined,
    tennatChecktatus:undefined,
};

export type aiAgentActions = ActionType<typeof actions>;

// @ts-ignore
export const aiAgentReducer = createReducer<AiAgentStateType, aiAgentActions>(
    initialState,
)
    .handleAction(
        actions.exchangeTokenWithInternalAdapter.success,
        (state: AiAgentStateType, action) => {
            return {
                ...state,
                token: action.payload,
                fetchTokenInProgress: false,
            };
        },
    )
    .handleAction(
        actions.exchangeTokenWithInternalAdapter.request,
        (state: AiAgentStateType) => {
            return {
                ...state,
                fetchTokenInProgress: true,
            };
        },
    )
    .handleAction(
        actions.exchangeTokenWithInternalAdapter.failure,
        (state: AiAgentStateType) => {
            return {
                ...state,
                fetchTokenInProgress: false,
            };
        },
    )
    // @ts-ignore
    .handleAction(actions.checkTenant.request, (state: AiAgentStateType) => {
        return {
            ...state,
            checkTenantInProgress: true,
        };
    })
    .handleAction(
        actions.checkTenant.success,
        (state: AiAgentStateType, action) => {
            return {
                ...state,
                checkTenantInProgress: false,
                tenantId: action.payload?.tenant_id,
                sign_in_link: action.payload?.sign_in_link,
                tennatChecktatus:action.payload?.status
            };
        },
    )
    .handleAction(actions.checkTenant.failure, (state: AiAgentStateType, action) => {
        return {
            ...state,
            checkTenantInProgress: false,
            tennatChecktatus:action.payload?.status
        };
    })

    // @ts-ignore
    .handleAction(
        actions.checkOrCreateTenant.request,
        (state: AiAgentStateType) => {
            return {
                ...state,
                checkTenantInProgress: true,
            };
        },
    )
    .handleAction(
        actions.checkOrCreateTenant.success,
        (state: AiAgentStateType, action) => {
            return {
                ...state,
                checkTenantInProgress: false,
                tenantId: action.payload?.tenant_id,
                sign_in_link: action.payload?.sign_in_link,
                tennatChecktatus: action.payload?.tenant_id ? 'existing' : state.tennatChecktatus,
            };
        },
    )
    .handleAction(
        actions.checkOrCreateTenant.failure,
        (state: AiAgentStateType) => {
            return { ...state, checkTenantInProgress: false };
        },
    )
    .handleAction(
        actions.getAiAgentsList.request,
        (state: AiAgentStateType) => {
            return {
                ...state,
                aiAgentsListLoading: true,
                aiAgentsListLoadingError:undefined
            };
        },
    )
    .handleAction(
        actions.getAiAgentsList.success,
        (state: AiAgentStateType, action) => {
            return {
                ...state,
                aiAgentsListLoading: false,
                aiAgentsList: action.payload,
            };
        },
    )
    .handleAction(
        actions.getAiAgentsList.failure,
        (state: AiAgentStateType, action) => {
            return {
                ...state,
                aiAgentsListLoading: false,
                aiAgentsListLoadingError:action.payload
            };
        },
    )
    .handleAction(
        actions.getAccessLink.success,
        (state: AiAgentStateType, action) => {
            return {
                ...state,
                accessLink: action.payload,
            };
        },
    );
export default aiAgentReducer;
